// import React from 'react'
// import { NavLink } from 'react-router-dom'
// import { SlHome } from 'react-icons/sl'
// import { BsWallet, BsGift } from 'react-icons/bs'
// import { FiUser, FiUsers } from 'react-icons/fi'
// import { AiOutlineMessage } from 'react-icons/ai'
// import { BiMessageSquareDetail } from 'react-icons/bi'

// const BottonMenu = ({ w3_close }) => {
//   return (
//     <div className="bottom_nav_wrapper">
//       <div className="bottom_nav_bar">

//         <NavLink exact to="/wallet" className="nav_item" activeClassName="active">
//           <img src="/wallet.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/refer" className="nav_item" activeClassName="active">
//           <img src="/bootom-refer.png" alt="" style={{marginRight:"60px"}} />
//         </NavLink>
       

//         {/* CENTER HOME BUTTON */}
//         <NavLink exact to="/landing" className="center_button" activeClassName="active_center">
//           <img src="/home.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/support" className="nav_item" activeClassName="active">
//           <img src="/customer-support.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/Profile" className="nav_item" activeClassName="active">
//           <img src="/bootom_user.png" alt="" />
//         </NavLink>

//       </div>
//     </div>

//   )
// }

// export default BottonMenu

import React from "react";
import { NavLink } from "react-router-dom";

const BottonMenu = ({ w3_close }) => {
  const itemStyle = {
    flex: 1,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
  };

  const iconStyle = {
    width: "24px",
    height: "24px",
    objectFit: "contain",
    filter: "grayscale(1) brightness(0) invert(1)",
    opacity: 0.95,
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        height: "54px",
        backgroundColor: "#000",
        zIndex: 9999,
        borderTop: "1px solid #222",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "54px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* HOME */}
        <NavLink
          exact
          to="/landing"
          activeClassName="active"
          style={itemStyle}
        >
          <img
            src="/home.png"
            alt="Home"
            style={iconStyle}
          />
        </NavLink>

        {/* WALLET */}
        <NavLink
          exact
          to="/wallet"
          activeClassName="active"
          style={itemStyle}
        >
          <img
            src="/wallet.png"
            alt="Wallet"
            style={iconStyle}
          />
        </NavLink>

        {/* REFER */}
        <NavLink
          exact
          to="/refer"
          activeClassName="active"
          style={itemStyle}
        >
          <img
            src="/bootom-refer.png"
            alt="Refer"
            style={iconStyle}
          />
        </NavLink>

        {/* SUPPORT */}
        <NavLink
          exact
          to="/support"
          activeClassName="active"
          style={itemStyle}
        >
          <img
            src="/customer-support.png"
            alt="Support"
            style={iconStyle}
          />
        </NavLink>

        {/* PROFILE */}
        <NavLink
          exact
          to="/Profile"
          activeClassName="active"
          style={itemStyle}
        >
          <img
            src="/bootom_user.png"
            alt="Profile"
            style={iconStyle}
          />
        </NavLink>
      </div>
    </div>
  );
};

export default BottonMenu;
